
const {
  IAM_USER_STATUS_ACTIVE,
  IAM_USER_STATUS_INACTIVE
} = require('./src/iamUserStatuses');

module.exports = {
  iamUserStatuses: {
    IAM_USER_STATUS_ACTIVE,
    IAM_USER_STATUS_INACTIVE,
  },
};
